import * as React from 'react';
import Box from '@mui/material/Box';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import Button from '@mui/material/Button';
import { FormGroup ,TextField,Typography } from '@mui/material';
import { IPrimaryContact } from '../SignupPage';

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  minHeight: '300px',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

interface SignupStep3Props {
  onNextClick: (data: IPrimaryContact) => void;
  onPreviousClick: VoidFunction;
  formData : IPrimaryContact;
}

export const SignupStep3 : React.FC<SignupStep3Props> = (props) => {

  const { control, handleSubmit } = useForm<IPrimaryContact>();
  
  const onSubmit: SubmitHandler<IPrimaryContact> = (data) => {
    props.onNextClick(data);
  };
 
  return (
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
        <Card variant="outlined">
          <Box sx={{ display: { xs: 'flex' } }}>
            <img src="/logo.png" alt="Logo" style={{ height: 40, paddingBottom:0 }} />  
          </Box>

          <Typography
              component="h1"
              variant="h4"
              sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
              >
            Please enter your company information
          </Typography>

          <Controller
            name="firstName"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                name={field.name}
                value={field.value}
                size="small"
                required
                onChange={field.onChange}
                id="firstName"
                label="First Name"
                sx={{ width: "100%" }}
                helperText=""
//                error={errors.firstName !== undefined}
              />
            )}
          />

          <Controller
            name="surname"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                name={field.name}
                value={field.value}
                size="small"
                required
                onChange={field.onChange}
                id="surname"
                label="Last Name"
                sx={{ width: "100%" }}
                helperText=""
                //error={errors.primaryContactSurname !== undefined}
              />
            )}
          />

          <Controller
            name="email"
            control={control}
            defaultValue=""
            render={({ field: { name, value, onChange } }) => (
              <TextField
                name={name}
                value={value}
                size="small"
                required
                onChange={onChange}
                label="Email Address"
                sx={{ width: "100%" }}
                // helperText={
                //   errors.email ? (
                //     <Typography variant="subtitle2">
                //       {errors.email?.message}
                //     </Typography>
                //   ) : (
                //     <></>
                //   )
                // }
                // error={errors.primaryContactEmail !== undefined}
              />
            )}
          />

          <Controller
            name="emailConfirm"
            control={control}
            defaultValue=""
            render={({ field: { name, value, onChange } }) => (
              <>
                <TextField
                  name={name}
                  value={value}
                  size="small"
                  required
                  onChange={onChange}
                  label="Confirm Email"
                  sx={{ width: "100%" }}
                  // helperText={
                  //   errors.primaryContactEmailConfirm ? (
                  //     <Mui.Typography variant="subtitle2">
                  //       {errors.primaryContactEmailConfirm?.message}
                  //     </Mui.Typography>
                  //   ) : (
                  //     <></>
                  //   )
                  // }
                  // error={errors.primaryContactEmailConfirm !== undefined}
                />
              </>
            )}
          />        

          <FormGroup row sx={{justifyContent:'flex-end'}}>
              <Button
                  variant="outlined"
                  color="primary"
                  sx={{ mt: 2, mr: 2 }}
                  onClick={props.onPreviousClick}
              >
                  Previous
              </Button>
              <Button
                  variant="outlined"
                  color="primary"
                  type="submit"
                  sx={{ mt: 2 }}
              >
                  Next
              </Button>
          </FormGroup>
          
        </Card>
      </form>
   
  )
}